import React from 'react';
import { CustomDialog } from '../CustomDialog';
import { useEvent } from '../../hooks/useEvent';

interface DialogUnlockEventProps {
  eventId: number; // event id to unlock
  onSuccess: () => void;  // Callback to refresh events list after unlocking
  onCancel: () => void; // Callback to close the dialog
}

export const DialogUnlockEvent: React.FC<DialogUnlockEventProps> = ({ eventId, onSuccess, onCancel }) => {
  const { handleUnlockEvent, updating } = useEvent();

  const handleUnlock = async () => {
    const success = await handleUnlockEvent(eventId);
    if (success) {
      onSuccess();
    }
    onCancel();
  };

  return (
    <CustomDialog
      title="Are you sure you want to unlock this event?"
      description='By unlocking, you will be required to resubmit your event for approval.'
      primaryButtonText="Yes, unlock this event"
      secondaryButtonText="Cancel"
      open={true}
      onClose={onCancel}
      onPrimaryButtonClick={handleUnlock}
      onSecondaryButtonClick={onCancel}
      disablePrimaryButton={updating}
    />
  );
}; 